import { useState, useEffect, ReactNode } from "react";
import { DeviceContext } from "./DeviceContext";
import { deviceService } from "../services/deviceService";

interface DeviceProviderProps {
  children: ReactNode;
}

// Registers in the background and renders children at once. Reads pick the id
// up from deviceService when it lands, so nothing here may gate them.
export function DeviceProvider({ children }: DeviceProviderProps) {
  const [deviceId, setDeviceId] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    deviceService
      .getDeviceId()
      .then((id) => {
        if (active) setDeviceId(id);
      })
      .catch((err) => {
        console.error("❌ Device registration error:", err);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <DeviceContext.Provider value={{ deviceId }}>
      {children}
    </DeviceContext.Provider>
  );
}
